/**
 * SCENE 10: THE EMBER REBORN (Post-Singularity Future)
 * Crystalline white space, zero-G obsidian handaxe, persistent glowing ember HUD & terminal line.
 */

import { ISceneLifecycle } from './ISceneLifecycle';
import { CameraState } from '../renderer/CameraSpline';
import { EventBus, EventType } from '../core/EventBus';
import { StateStore, StateBitmask } from '../state/Store';

export class Scene10_EmberReborn implements ISceneLifecycle {
  public id = 9;
  public name = 'The Ember Reborn';
  public era = 'Post-Singularity Future';

  private eventBus: EventBus;
  private store: StateStore;
  private floatAngle: number = 0;
  private isTerminalOpened: boolean = false;
  private unsubscribeList: Array<() => void> = [];

  constructor() {
    this.eventBus = EventBus.getInstance();
    this.store = StateStore.getInstance();
  }

  public async preload(): Promise<void> { return Promise.resolve(); }
  public mount(): void {}

  public activate(): void {
    const unsubDown = this.eventBus.subscribe(EventType.INPUT_POINTER_DOWN, () => {
      if (!this.isTerminalOpened) {
        this.isTerminalOpened = true;
        this.store.setFlag(StateBitmask.EMBER_REBORN, true);
        this.eventBus.emit(
          EventType.ACCESSIBILITY_ANNOUNCE,
          0, 0, 0, 0, 0, 1, 9,
          'Floating zero-gravity obsidian handaxe touched. Terminal line [INITIATE COLLABORATION] unlocked.'
        );
        // Open terminal modal
        const modal = document.getElementById('terminal-modal');
        if (modal) {
          modal.classList.remove('hidden');
        }
      }
    });

    this.unsubscribeList.push(unsubDown);
  }

  public update(dt: number): void {
    this.floatAngle += dt * 1.5;
  }

  public render(ctx: CanvasRenderingContext2D, width: number, height: number, _camera: CameraState): void {
    ctx.save();
    const cx = width / 2;
    const cy = height / 2;

    // Pure Crystalline White Chamber
    ctx.fillStyle = '#f8fafc';
    ctx.fillRect(0, 0, width, height);

    // Floating Obsidian Handaxe in zero gravity wrapped in fiber-optic light thread
    const floatY = cy + Math.sin(this.floatAngle) * 15;

    // Fiber-optic light thread ring around handaxe
    ctx.strokeStyle = '#e25b2d';
    ctx.lineWidth = 3;
    ctx.shadowColor = 'rgba(226, 91, 45, 0.8)';
    ctx.shadowBlur = 20;

    ctx.beginPath();
    ctx.ellipse(cx, floatY, 80, 45, this.floatAngle * 0.3, 0, Math.PI * 2);
    ctx.stroke();

    // Obsidian Handaxe Shape
    ctx.fillStyle = '#0f172a';
    ctx.beginPath();
    ctx.moveTo(cx, floatY - 50);
    ctx.lineTo(cx + 40, floatY + 20);
    ctx.lineTo(cx, floatY + 50);
    ctx.lineTo(cx - 40, floatY + 20);
    ctx.closePath();
    ctx.fill();

    ctx.font = '600 13px "Inter", sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#0f172a';
    ctx.shadowBlur = 0;
    ctx.fillText('THE OBSIDIAN EMBER  //  HUMAN CURIOSITY', cx, floatY + 90);

    ctx.font = '500 11px monospace';
    ctx.fillStyle = '#e25b2d';
    ctx.fillText('[ TOUCH HANDAXE TO INITIATE DIRECT COLLABORATION ]', cx, height - 40);

    ctx.restore();
  }

  public deactivate(): void {
    this.unsubscribeList.forEach(fn => fn());
    this.unsubscribeList = [];
  }
  public unmount(): void {}
  public dispose(): void {}
}
